import { withNamespaces } from "react-i18next";

const Alert = ({
    t,
    icon,
    title,
    message
}) => {
    return (
        <div className="ai-onboarding-alert d-flex justify-content-start align-items-center">
            {icon && (
                <div className="alert-icon">
                    <img 
                        src={icon} 
                        alt="alert icon" 
                        style={{
                            maxWidth: '200px'
                        }}
                    />
                </div>
            )}

            <div className="alert-content">
                {title && (
                    <h4>{t(title)}</h4>
                )}

                {message}
            </div>
        </div>
    )
}

export default withNamespaces()(
    Alert
);